import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { PlaylistService, RemoteApiService } from './services';
import { FeatureToggleService } from './services/feature-toggle.service';
import { environment } from './../../environments/environment';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [RemoteApiService, PlaylistService,  {
    provide: FeatureToggleService,
    useFactory: (): FeatureToggleService => new FeatureToggleService(environment.featureToggle)
  }]
})
export class CoreModule {

  constructor (@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }



}
